import React from 'react'
import { Button } from 'reactstrap'

type PropsButtonAceptar = {
    handleClickAceptar: (posiblesArgs?:any) => void,
    nombreBoton?:string 
    className?:string,
    disabledButton?:boolean
}

export default function ButtonAceptar(props:PropsButtonAceptar) {
  return (
    <Button 
      disabled = {props.disabledButton !== undefined && props.disabledButton === true }
      onClick = {() => props.handleClickAceptar()}
      className = {props.className??""}
    >
      {`${props.nombreBoton !== undefined ? props.nombreBoton:"Aceptar"}`}
    </Button>
  )
}
